module.exports = __webpack_public_path__ + "static/img/4_2.20ea7dcf.jpg";